import { render } from "./ComputeSelection.vue?vue&type=template&id=dd85131c&scoped=true"
import script from "./ComputeSelection.vue?vue&type=script&lang=js"
export * from "./ComputeSelection.vue?vue&type=script&lang=js"

import "./ComputeSelection.vue?vue&type=style&index=0&id=dd85131c&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd85131c"]])

export default __exports__